import config from "../config";

import logger from "../logger";

const indexOfEnd = (string, subString) => {
  const io = string.indexOf(subString);
  return io === -1 ? -1 : io + subString.length;
};

/**
 * Formats image URLs with options of size parameters
 * Nualang ones are formatted and third party URLs are ignored
 * @param path
 * @param height
 * @param width
 * @returns {string|null}
 */
export function getImageUrlWithSize(path = "", height, width) {
  if (!path) return null;

  const pattern = /^((http|https|):\/\/)/;

  let key = "";

  // Decodes URL and gets S3 path key when it's a
  // or returns URL if from third party
  if (pattern.test(path)) {
    const nualangDomain = "nualang.com/";

    if (path.includes(nualangDomain) && !path.includes("image-creator")) {
      const encodedIndex = indexOfEnd(path, nualangDomain);
      const encoded = path.substring(encodedIndex, path.length);
      let decoded = {};
      try {
        decoded = JSON.parse(Buffer.from(encoded, "base64").toString("utf-8"));
      } catch (error) {
        logger.error(error);
      }
      if (decoded.bucket === config.ImageBucket) {
        key = decoded.key;
      } else {
        if (width === 25) {
          return null;
        }
        return path;
      }
    } else {
      return path;
    }
  } else {
    key = path;
  }

  const imageRequest = JSON.stringify({
    bucket: config.ImageBucket,
    key,
    edits: {
      resize: {
        width: width || undefined,
        height: height || undefined,
      },
    },
  });

  return `${config.ImageURL}/${Buffer.from(imageRequest).toString("base64")}`;
}

export function getImageUrl(photoKey, edits) {
  if (!photoKey) return null;

  const imageRequest = JSON.stringify({
    bucket: config.ImageBucket,
    key: photoKey,
    edits,
  });

  return `${config.ImageURL}/${Buffer.from(imageRequest).toString("base64")}`;
}

export default getImageUrlWithSize;
